<template>
  <el-card :class="['box-card',optStatusEdit?'':'not-click'] " style="height: 25%;">
    <div slot="header" style="padding: 2px 0">
      <span>{{ $t('SystemMaintenance.WarningSettings') }}</span>
    </div>
    <el-form style="width:100%;" :disabled="!optStatusEdit" label-position="left" label-width="100px">
      <el-form-item :label="$t('SystemMaintenance.WarningSwitch')">
        <el-radio-group v-model="sopWarningConfig.open">
          <el-radio :label="true">{{ $t('SystemMaintenance.TurnOnWarning') }}</el-radio>
          <el-radio :label="false">{{ $t('SystemMaintenance.TurnOffWarning') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_EarlyWarning')">
        <el-select v-model="sopWarningConfig.warningDateField">
          <el-option :value="0" :label="$t('SystemMaintenance.SailingTimeETD')" />
          <el-option :value="1" :label="$t('SystemMaintenance.ArrivalTimeETA')" />
          <el-option :value="2" :label="$t('SystemMaintenance.OpenPortTime')" />
          <el-option :value="3" :label="$t('SystemMaintenance.ClosingPortTime')" />
          <el-option :value="4" :label="$t('SystemMaintenance.ClosingTimeForOrders')" />
          <el-option :value="5" :label="$t('SystemMaintenance.CustomsClosingTime')" />
          <el-option :value="6" :label="$t('SystemMaintenance.ScheduledBerthingDate')" />
          <el-option :value="7" :label="$t('SystemMaintenance.ScheduledDepartureDate')" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('SystemMaintenance.WarningTime')">
        <el-select v-model="sopWarningConfig.warningType" style="width: 100px">
          <el-option :value="0" :label="$t('SystemMaintenance.Advance')" />
          <el-option :value="1" :label="$t('SystemMaintenance.Delay')" />
        </el-select>
        <el-input v-model="sopWarningConfig.warningHour" style="width: 50px" />
        <span>{{ $t('SystemMaintenance.HoursWarningReminder') }}</span>
      </el-form-item>
      <el-form-item :label="$t('queryJob.warningLevel')">
        <el-radio-group v-model="sopWarningConfig.warningLevel">
          <el-radio :label="0">{{ $t('SystemMaintenance.Highest') }}</el-radio>
          <el-radio :label="1">{{ $t('SystemMaintenance.High') }}</el-radio>
          <el-radio :label="2">{{ $t('SystemMaintenance.Medium') }}</el-radio>
          <el-radio :label="3">{{ $t('SystemMaintenance.Low') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import * as sopWarningConfigApi from '@/api/sysManage/baseConfig/sopWarningConfig'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'TrackingDetailSopWarningConfig',
  props: {
    optStatusEdit: { type: Boolean, required: true },
    trackingDetail: { type: Object, default: null }
  },
  data() {
    return {
      sopWarningConfig: {
        trackInfoId: '',
        trackInfoDetailId: '',
        open: true,
        warningDateField: 0,
        warningType: 0,
        warningHour: 0,
        warningLevel: 0
      }
    }
  },
  created() {
  },
  methods: {
    loadTrackSopWarningConfig(trackingDetailUuid) {
      if (this.trackingDetail && this.trackingDetail.uuid || trackingDetailUuid) {
        const loading = getLoading()
        trackingDetailUuid = trackingDetailUuid || this.trackingDetail.uuid
        sopWarningConfigApi.loadSopWarningConfig({ trackingDetailUuid }).then(resp => {
          this.loadSopWarningConfigHandler(resp)
        }).finally(() => loading.close())
      } else {
        this.loadSopWarningConfigHandler()
      }
    },
    loadSopWarningConfigHandler(resp) {
      if (!resp || !resp.data) {
        this.initForm()
        this.sopWarningConfig.open = true
        this.sopWarningConfig.warningHour = 72
      } else {
        Object.assign(this.sopWarningConfig, resp.data)
      }
    },
    initForm() {
      this.sopWarningConfig = {
        open: true,
        warningDateField: 0,
        warningType: 0,
        warningHour: 0,
        warningLevel: 0
      }
    },
    save(trackingUuid, trackingDetailUuid) {
      const sopWarningConfig = {}
      Object.assign(sopWarningConfig, this.sopWarningConfig)
      sopWarningConfig.trackInfoId = trackingUuid || this.trackingDetail.trackingUuid
      sopWarningConfig.trackInfoDetailId = trackingDetailUuid || this.trackingDetail.uuid
      sopWarningConfig.open = Number(this.sopWarningConfig.open) === 1
      sopWarningConfig.warningDateField = !this.sopWarningConfig.warningDateField ? 0 : Number(this.sopWarningConfig.warningDateField)
      sopWarningConfig.warningType = !this.sopWarningConfig.warningType ? 0 : Number(this.sopWarningConfig.warningType)
      sopWarningConfig.warningHour = Number(this.sopWarningConfig.warningHour)
      sopWarningConfig.warningLevel = Number(this.sopWarningConfig.warningLevel)
      const loading = getLoading()
      sopWarningConfigApi.save(sopWarningConfig).finally(() => loading.close())
    }
  }
}
</script>

<style scoped>

</style>
